import React, { useMemo } from "react";
import { Link, useLocation } from "react-router-dom";
import {
  UpgradeNav,
  MainNav,
  ComponentsNav,
  FormsNav,
  WidgetsNav,
  ChartsNav,
} from "../Layout/AppNav/NavItems";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faHouse } from "@fortawesome/free-solid-svg-icons";

const flattenNav = (groups) => {
  const map = new Map();
  const addItem = (item) => {
    if (item.to) map.set(item.to, item.label || item.to);
    if (item.content && Array.isArray(item.content)) item.content.forEach(addItem);
  };
  groups.forEach((group) => group.forEach(addItem));
  return map;
};

const toTitle = (segment) =>
  segment
    .replace(/[-_]+/g, " ")
    .replace(/\b\w/g, (c) => c.toUpperCase());

const Breadcrumbs = () => {
  const location = useLocation();
  const labelMap = useMemo(
    () => flattenNav([UpgradeNav, MainNav, ComponentsNav, FormsNav, WidgetsNav, ChartsNav]),
    []
  );

  const path = location.pathname || "/";
  if (path.startsWith("/login")) return null;

  const segments = path.split("/").filter(Boolean);
  const crumbs = segments.map((_, idx) => 
    "/" + segments.slice(0, idx + 1).join("/")
  );

  const items = crumbs.map((p, i) => ({
    path: p,
    label: labelMap.get(p) || toTitle(p.split("/").pop() || ""),
    isLast: i === crumbs.length - 1,
  }));

  if (items.length === 0) return null;

  return (
    <nav aria-label="breadcrumb" style={{ marginLeft: 8 }}>
      <ol className="breadcrumb mb-0" style={{ background: "transparent", color: 'var(--cryrDarkBlue)' }}>
        <li className="breadcrumb-item">
          <Link to="/" aria-label="Home" style={{ color: 'var(--cryrDarkBlue)' }}>
            <FontAwesomeIcon icon={faHouse} />
          </Link>
        </li>
        {items.map((it) => (
          <li key={it.path} className={`breadcrumb-item ${it.isLast ? "active" : ""}`} aria-current={it.isLast ? "page" : undefined} style={{ color: 'var(--cryrDarkBlue)' }}>
            {it.isLast ? (
              <span style={{ color: 'var(--cryrDarkBlue)' }}>{it.label}</span>
            ) : (
              <Link to={it.path} style={{ color: 'var(--cryrDarkBlue)' }}>
                {it.label}
              </Link>
            )}
          </li>
        ))}
      </ol>
    </nav>
  );
};

export default Breadcrumbs;


